export { default } from './MetaTags'
